<template>
  <div class="p-4 sm:p-6 lg:p-10 max-w-7xl mx-auto">
    
    <PageHeader 
      title="Ścieżka rozwoju"
     
    />

    <FormSection :title="fullname" subtitle="Sprawdź swój postęp i odblokuj kolejne poziomy rozwoju w naszej ofercie kursów improwizacji."
    >
      <!-- Ściezka Improwizacji Section -->
      <div v-if="tagsByCategory.impro.length > 0" class="mb-8">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">Ścieżka Improwizacji</h3>
        <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          <PathTag
            v-for="t in tagsByCategory.impro"
            :key="t.id"
            :tag="t"
            :width="160"
            :height="190"
            :frameBorderClass="getFrameBorderClass(t)"
            @mouseover="hoveredTagId = t.id"
            @mouseleave="hoveredTagId = null"
          />
        </div>
      </div>

      <!-- Ściezka Aktorska Section -->
      <div v-if="tagsByCategory.acting.length > 0" class="mb-8">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">Ścieżka Aktorska</h3>
        <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          <PathTag
            v-for="t in tagsByCategory.acting"
            :key="t.id"
            :tag="t"
            :width="160"
            :height="190"
            :frameBorderClass="getFrameBorderClass(t)"
            @mouseover="hoveredTagId = t.id"
            @mouseleave="hoveredTagId = null"
          />
        </div>
      </div>

      <!-- Ściezka Section (for tags with empty or null category) -->
      <div v-if="tagsByCategory.other.length > 0" class="mb-8">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">Ścieżka</h3>
        <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          <PathTag
            v-for="t in tagsByCategory.other"
            :key="t.id"
            :tag="t"
            :width="160"
            :height="190"
            :frameBorderClass="getFrameBorderClass(t)"
            @mouseover="hoveredTagId = t.id"
            @mouseleave="hoveredTagId = null"
          />
        </div>
      </div>
    </FormSection>
  </div>
</template>

<script>
import { ref } from 'vue';
import PageHeader from '../../components/PageHeader.vue';
import rpAPI from '@shared/service/rpAPI.js';
import Globals from '@shared/model/Globals.js';
import Tag from '@shared/model/Tag.js';
import PathTag from '../../components/PathTag.vue';
import FormSection from '../../components/FormSection.vue';


export default {
  name: 'LevelPage',
  components: {
    PageHeader,
    PathTag,
    FormSection,
  },
  data() {
    return {
      rpAPI,
      fullname: '',
      tags: [],
      levels: [],
      hoveredTagId: null,
    };
  },
  computed: {
    tagsByCategory() {
      const sortByField = (tags) => [...tags].sort((a, b) => a.sort - b.sort);
      return {
        impro: sortByField(this.tags.filter(t => t.category === 'impro')),
        acting: sortByField(this.tags.filter(t => t.category === 'acting')),
        other: sortByField(this.tags.filter(t => !t.category || t.category === '')),
      };
    }
  },
  methods: {
    getFrameBorderClass(tag) {
      const isHovered = this.hoveredTagId === tag.id;
      const isUnlocked = this.levels.some(id => String(id) === String(tag.id));
      if (isUnlocked) {
        return 'border-primary-500';
      }
      return isHovered ? 'border-gray-300' : 'border-gray-300 opacity-50';
    }
  },
  async mounted() {
    // Tutaj możesz dodać logikę do pobierania danych o poziomach rozwoju z backendu
      const data = await rpAPI.getPathTags();

      this.tags = data?.map(t => new Tag(t)) || [];

      const user = rpAPI.user;

      if (!user) return;

      // załaduj profile, żeby mieć dostęp do dodatkowych pól
      await user.initProfiles();
      const defaultProfile = user.defaultProfile();
      if (!defaultProfile) return;
   
      this.levels = defaultProfile.level || [];


      console.log("Pobrane dane o poziomach użytkownika:", defaultProfile.level);
      this.fullname = user.first_name + ' ' + user.last_name;

      // sort this.tags, so that tags with ids in this.levels come first, and the rest are sorted by title
      this.tags.sort((a, b) => {
        const aInLevels = this.levels.some(id => String(id) === String(a.id));
        const bInLevels = this.levels.some(id => String(id) === String(b.id));
        if (aInLevels && !bInLevels) return -1;
        if (!aInLevels && bInLevels) return 1;
        return a.sort - b.sort || a.title.localeCompare(b.title);
      });

    }
  }


</script>
